import { CSSProperties } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';

import CloseButton from 'components/CloseButton';
import Headline from 'components/headline';
import Icon from 'components/Icon';
import Cluster from 'components/Layout/Cluster';
import Column from 'components/Layout/Column';
import Columns from 'components/Layout/Columns';
import Flow from 'components/Layout/Flow';
import MainButton from 'components/MainButton';
import SessionIcon from 'components/SessionIcon';
import Typography from 'components/Typography';
import PageLayout from '../../components/Layout/PageLayout';
import MainNav from '../../components/MainNav';
import MainNavItem from '../../components/MainNavItem';
import GapSizes from 'utils/constants/gap-sizes';
import AddButton from 'components/AddButton';
import Select from 'components/Inputs/Select';
import Textarea from 'components/Inputs/Textarea';
import CompanyLogo from 'components/CompanyLogo';
import FilePreview from 'components/FilePreview';

const SessionBase = () => {
  /*const users = [
    {
      id: '1',
      initials: 'WI',
      name: 'With Image',
      imgUrl: 'http://satyr.io/60/f9a'
    },
    {
      id: '2',
      initials: 'WI',
      name: 'With Image',
      imgUrl: 'http://satyr.io/60/a9f'
    },
    {
      id: '3',
      initials: 'NI',
      name: 'No Image at all'
    },
    {
      id: '4',
      initials: 'WI',
      name: 'With Image',
      imgUrl: 'http://satyr.io/60/f9a'
    },
    {
      id: '5',
      initials: 'WI',
      name: 'With Image',
      imgUrl: 'http://satyr.io/60/f9a'
    },
    {
      id: '6',
      initials: 'NI',
      name: 'No Image'
    },
    {
      id: '7',
      initials: 'WI',
      name: 'With Image',
      imgUrl: 'http://satyr.io/60/f9a'
    },
    {
      id: '8',
      initials: 'WI',
      name: 'With Image',
      imgUrl: 'http://satyr.io/60/f9a'
    }
  ];*/

  const mainNav = (
    <MainNav>
      <MainNavItem
        label="Lab"
        iconName="lab"
        active={true}
        to="/styleguides/page-layout"
      />
      <MainNavItem label="Network" iconName="" to="/styleguides" />
      <MainNavItem
        label="Settings"
        iconName="cogwheel"
        to="/styleguides/page-layout"
      />
    </MainNav>
  );

  return (
    <PageLayout mainNav={mainNav} reduced={true}>
      <Columns columnTemplate="1fr 22.1875rem" gap={GapSizes.NONE}>
        <Column>
          <div className="session session--extra-bottom-space">
            <div className="session__fixed">
              <Cluster justification="flex-end">
                <div className="timer">
                  <Icon name="timer-stop" />
                  <div className="timer__body">
                    Timer
                    <br />
                    starten
                  </div>
                </div>
                <div className="timer timer--running">
                  <Icon name="timer-running" />
                  <div className="timer__body">05:34</div>
                </div>
                <CloseButton label="schließen" iconName="cross" />
              </Cluster>
            </div>
            <div
              className="progress"
              style={{ '--progress-indicator': 80 } as CSSProperties}
            />
            <nav className="point-navigation">
              <ul>
                <li>
                  <Link to="#">
                    <span className="sr-only">Step 1</span>
                  </Link>
                </li>
                <li>
                  <Link to="#" className="active">
                    <span className="sr-only">Step 2</span>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <span className="sr-only">Step 3</span>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <span className="sr-only">Step 4</span>
                  </Link>
                </li>
              </ul>
            </nav>
            <div className="session__top">
              <Flow flowSpace="0.125rem">
                <SessionIcon />
                <Typography opaque={true}>
                  Schritt 04 von 04 // Auswahl einer WKW-Frage
                </Typography>
                <Typography size="large">
                  Wähle aus allen von Dir gesammelte WKWs die deiner Meinung
                  nach beste „Wie-Können-Wir-Frage“ aus und trage diese in das
                  das Feld ein.
                </Typography>
                <Typography size="large">
                  <Link to="#">Was genau ist zu machen?</Link>
                </Typography>
              </Flow>
            </div>
            <div className="decoration-select-benchmark"></div>
            <div className="session__bottom">
              <Columns columnTemplate="11.125rem 1fr" gap={GapSizes.S}>
                <Column>
                  <AddButton iconName="cloud-up" label="Datei hinzufügen" />
                </Column>
                <Column>
                  <Flow flowSpace="0.5rem">
                    <Select name="MySelect">
                      <option value="bla">bla</option>
                      <option value="blabla">blabla</option>
                      <option value="blub">blubb</option>
                    </Select>
                    <Textarea
                      name="myTextarea"
                      placeholder="Füge eine Kurzbeschreibung zum Lösungsbaustein hinzu"
                    ></Textarea>
                  </Flow>
                </Column>
              </Columns>
              <div className="session__actions">
                <Cluster justification="flex-end">
                  <MainButton secondary={true}>Entwurf speichern</MainButton>
                  <MainButton>Weiter</MainButton>
                </Cluster>
              </div>
            </div>

            <div className="session__bottom">
              <Columns columnTemplate="11.125rem 1fr" gap={GapSizes.S}>
                <Column>
                  <div className="logo-with-thumbnail">
                    <div className="logo-with-thumbnail__thumbnail">
                      <FilePreview
                        imgUrl="http://satyr.io/300x400/5"
                        alt="Alt-Text"
                        onDestroy={() => null}
                      />
                    </div>
                    <div className="logo-with-thumbnail__logo">
                      <CompanyLogo
                        alt="Company"
                        imgUrl="http://satyr.io/100x100/6"
                      />
                    </div>
                  </div>
                </Column>
                <Column>
                  <Flow flowSpace="0.5rem">
                    <Select name="MySelect">
                      <option value="bla">bla</option>
                      <option value="blabla">blabla</option>
                      <option value="blub">blubb</option>
                    </Select>
                    <Textarea
                      name="myTextarea"
                      placeholder="Füge eine Kurzbeschreibung zum Lösungsbaustein hinzu"
                    ></Textarea>
                  </Flow>
                </Column>
              </Columns>
              <div className="session__actions">
                <Cluster justification="flex-end">
                  <MainButton secondary={true}>Entwurf speichern</MainButton>
                  <MainButton>Weiter</MainButton>
                </Cluster>
              </div>
            </div>
            <div className="session__fixed-bottom">
              <Cluster justification="flex-end">
                <MainButton secondary={true}>Entwurf speichern</MainButton>
                <MainButton>Weiter</MainButton>
              </Cluster>
            </div>
          </div>
        </Column>
        <Column>
          <div className="session-sidebar">
            <div className="session-sidebar__scroll-container">
              <div className="session-sidebar__header">
                <Headline tag="h2" size="M" opaque={true}>
                  01. Session: <br />
                  Definition Kundenfokus
                </Headline>
              </div>

              <Flow flowSpace="2.5rem">
                <div className="sidebar-teaser">
                  <div className="sidebar-teaser__body">
                    <SessionIcon width="2.625rem" />
                    <Flow flowSpace="0.125rem">
                      <Typography size="small">
                        Post-It Vorlage zum{' '}
                        <Link to="#">selber ausdrucken</Link> oder{' '}
                        <Link to="#">Kaufen</Link>
                      </Typography>
                      <Typography size="smaller" opaque={true}>
                        2 days ago
                      </Typography>
                    </Flow>
                  </div>
                  <Link to="#">
                    <div className="sidebar-teaser__decoration">
                      <img
                        className="sidebar-teaser__image"
                        src="https://satyr.io/280x230"
                        alt="Some nice color"
                      />
                      <div className="sidebar-teaser__icon">
                        <Icon name="arrow-down" />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="sidebar-teaser">
                  <div className="sidebar-teaser__body">
                    <SessionIcon width="2.625rem" />
                    <Flow flowSpace="0.125rem">
                      <Typography size="small">
                        Post-It Vorlage zum{' '}
                        <Link to="#">selber ausdrucken</Link> oder{' '}
                        <Link to="#">Kaufen</Link>
                      </Typography>
                      <Typography size="smaller" opaque={true}>
                        2 days ago
                      </Typography>
                    </Flow>
                  </div>
                  <div className="sidebar-teaser__decoration">
                    <img
                      className="sidebar-teaser__image"
                      src="https://satyr.io/280x430"
                      alt="Some nice color"
                    />
                    <div className="sidebar-teaser__icon">
                      <Icon name="arrow-down" />
                    </div>
                  </div>
                </div>

                <div className="sidebar-teaser">
                  <div className="sidebar-teaser__body">
                    <SessionIcon width="2.625rem" />
                    <Flow flowSpace="0.125rem">
                      <Typography size="small">
                        Post-It Vorlage zum{' '}
                        <Link to="#">selber ausdrucken</Link> oder{' '}
                        <Link to="#">Kaufen</Link>
                      </Typography>
                      <Typography size="smaller" opaque={true}>
                        2 days ago
                      </Typography>
                    </Flow>
                  </div>
                  <div className="sidebar-teaser__decoration">
                    <img
                      className="sidebar-teaser__image"
                      src="https://satyr.io/280x230"
                      alt="Some nice color"
                    />
                    <div className="sidebar-teaser__icon">
                      <Icon name="arrow-down" />
                    </div>
                  </div>
                </div>

                <div className="sidebar-teaser">
                  <div className="sidebar-teaser__body">
                    <SessionIcon width="2.625rem" />
                    <Flow flowSpace="0.125rem">
                      <Typography size="small">
                        Post-It Vorlage zum{' '}
                        <Link to="#">selber ausdrucken</Link> oder{' '}
                        <Link to="#">Kaufen</Link>
                      </Typography>
                      <Typography size="smaller" opaque={true}>
                        2 days ago
                      </Typography>
                    </Flow>
                  </div>
                  <div className="sidebar-teaser__decoration">
                    <article className="rainbow-card-compact rainbow-card-compact--with-image rainbow-card-compact--simple rainbow-card-compact--company">
                      <div className="rainbow-card-compact__body">
                        <div className="rainbow-card-compact__company">
                          9ELEMENTS
                        </div>
                        <div className="rainbow-card-compact__title">
                          Video-Darstellung würde dann hier stehen
                        </div>
                        <a className="rainbow-card-compact__link" href="/link">
                          ...
                        </a>
                      </div>
                    </article>
                  </div>
                </div>
              </Flow>
            </div>
          </div>
        </Column>
      </Columns>
    </PageLayout>
  );
};

export default () => (
  <Switch>
    <Route path="/styleguides/sessionbase" component={SessionBase} />
  </Switch>
);
